import ReactGA from 'react-ga4';

// Initialize GA4
export const initGA = (measurementId) => {
  ReactGA.initialize(measurementId);
};

// Track page views
export const trackPageView = (page) => {
  ReactGA.send({ hitType: "pageview", page });
}; 